// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3i9b7","empty":"ModalGraph_empty__1xH_e"};